export default __webpack_public_path__ + "static/media/MARTES.599a2aac.jpeg";